import Reveal from "./Reveal";

export default function Ambaari() {
  return (
    <section data-testid="ambaari-section" className="relative bg-[#160705] py-32 md:py-48 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: "radial-gradient(ellipse 55% 45% at 50% 50%, rgba(198,161,91,0.08), transparent 70%)" }}
      />
      <div className="relative max-w-[1600px] mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="text-brass-soft/80 text-xs tracking-[0.5em] uppercase">
            The House of Jaipur Furniture presents
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <h2
            data-testid="ambaari-wordmark"
            className="shimmer-text font-display mt-8 text-[16vw] md:text-[11vw] leading-none tracking-[0.12em] font-light"
          >
            AMBAARI
          </h2>
        </Reveal>
        <Reveal delay={0.22}>
          <p className="mt-10 text-ivory/60 font-light max-w-xl mx-auto leading-relaxed text-base">
            A new factory. A new brand. A new way to bring Jaipur home —
            with its own dedicated e-commerce experience.
          </p>
          <div className="mt-12 inline-flex items-center gap-4 border border-brass/40 px-8 py-3">
            <span className="w-2 h-2 rounded-full bg-brass animate-pulse" />
            <span className="text-brass-soft text-xs tracking-[0.35em] uppercase">Arriving soon</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
